export const LOCALE = undefined;
